export default __webpack_public_path__ + "static/media/Props_FIN11.dcfccb65.png";